import api from './api';

export const listCourses = () =>
  api.get('/courses').then(r => r.data.courses);

export const getNewThisWeek = () =>
  api.get('/courses/new-this-week').then(r => r.data);

export const getCourseDetail = (courseId) =>
  api.get(`/courses/${courseId}`).then(r => r.data.course);

export const getLesson = (courseId, lessonId) =>
  api.get(`/courses/${courseId}/lessons/${lessonId}`).then(r => r.data.lesson);

export const completeLesson = (courseId, lessonId) =>
  api.post(`/courses/${courseId}/lessons/${lessonId}/complete`).then(r => r.data.progress);
